module.exports = __webpack_public_path__ + "bin/eb78209ec362d62c4324803fd8301982.png";